import {HTTP} from './common'

export const ProjectApi = {


    projects() {
        return HTTP.get('/projects/').then(response => {
            return response.data
        });
    },

    object(id) {
        return HTTP.get(`/projects/${id}/`).then(response => {
            return response.data
        });
    },
    create_project(data) {
        return HTTP.post('/projects/create_project/', data).then(response => {
            return response.data
        });
    },

    resource_all_list(query) {
        return HTTP.get(`projects/resource_all_list/${query?'?'+query:''}`).then(response => {
            return response.data
        });
    },

    get_review_settings(project_id) {
        return HTTP.get(`projects/${project_id}/get_settings/`).then(response => {
            return response.data
        });
    },

    get_alert_settings(project_id) {
        return HTTP.get(`projects/${project_id}/get_alert_settings/`).then(response => {
            return response.data
        });
    },
    save_alert_settings(project_id, data) {
        return HTTP.post(`projects/${project_id}/save_alert_settings/`, data).then(response => {
            return response.data
        });
    },

    get_auto_replies(project_id) {
        return HTTP.get(`projects/${project_id}/get_auto_replies/`).then(response => {
            return response.data
        });
    },
    save_auto_replies(project_id, data) {
        return HTTP.post(`projects/${project_id}/save_auto_replies/`, data).then(response => {
            return response.data
        });
    },

    save_review_settings(project_id, data) {
        return HTTP.post(`projects/${project_id}/save_settings/`, data).then(response => {
            return response.data
        });
    },

    delete_project(project_id) {
        return HTTP.post(`projects/${project_id}/delete_project/`).then(response => {
            return response.data
        });
    },

    upload_marked_link(project_id, data) {
        return HTTP.post(`projects/${project_id}/upload_marked_link/`, data).then(response => {
            return response.data
        });
    },

    reviews_tags(project_id, page, size) {
        return HTTP.get(`projects/${project_id}/reviews_tags/?page=${page}&size=${size}`).then(response => {
            return response.data
        });
    },

    add_tag(project_id, data) {
        return HTTP.post(`projects/${project_id}/add_tag/`, data).then(response => {
            return response.data
        });
    },

    save_tag(project_id, data) {
        return HTTP.post(`projects/${project_id}/save_tag/`, data).then(response => {
            return response.data
        });
    },
    remove_tag(project_id, data) {
        return HTTP.post(`projects/${project_id}/remove_tag/`, data).then(response => {
            return response.data
        });
    },
    add_category(project_id, data) {
        return HTTP.post(`projects/${project_id}/add_category/`, data).then(response => {
            return response.data
        });
    },
    save_category(project_id, data) {
        return HTTP.post(`projects/${project_id}/save_category/`, data).then(response => {
            return response.data
        });
    },
    delete_category(project_id, data) {
        return HTTP.post(`projects/${project_id}/delete_category/`, data).then(response => {
            return response.data
        });
    },
    start_parser(project_id) {
        return HTTP.get(`projects/${project_id}/start_parser/`).then(response => {
            return response.data
        });

    },
    start_analyse(project_id) {
        return HTTP.get(`projects/${project_id}/start_analyse/`).then(response => {
            return response.data
        });
    },

    get_user_perm() {
        return HTTP.get(`permission/`).then(response => {
            return response.data
        });
    },
    delete_user_perm(perm_id, project_id) {
        return HTTP.delete(`permission/${perm_id}/`).then(response => {
            return response.data
        });
    },
    add_user_perm(data) {
        return HTTP.post(`permission/create_user/`, data).then(response => {
            return response.data
        });
    },
};


